import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { IDropdownItem } from "./dropdown.component";

@Component({
	selector: "autocomplete",
	template: `
<div class="row">
	<div class="col-sm-12">
		<input class="form-control" 
			[ngClass]="{'text-primary': isSelected}"
			type="text"
			spellcheck="false"
			(focus)="setShowList(true)" 
			(blur)="setShowList(false)" 
			[(ngModel)]="model.text"
			(keyup)="filterItems()">
	
		<div class="list-group" [hidden]="!showList" style="position:absolute;z-index:999;width:100%">
			<a *ngFor="let item of filteredList | slice : 0 : 10" 
				(mousedown)="selectItem(item)" 
				class="list-group-item padding-top-xxs padding-bottom-xxs" 
				[ngClass]="{'active': model.text===item.text}">
				
				<span class="text-tertiary">{{item.text}}</span>
			</a>
			<a class="list-group-item padding-top-xxs padding-bottom-xxs" *ngIf="filteredList.length<1">
				<span class="text-tertiary">No results matched "{{model.text}}"</span>
			</a>
		</div>
	</div>
</div>`
})

export class AutocompleteComponent implements OnChanges {
	@Input() items: IDropdownItem[] = [];
	@Input() model: IDropdownItem = { text: "" };
	@Output() autocompleteChanged: EventEmitter<IDropdownItem> = new EventEmitter<IDropdownItem>();

	public filteredList: IDropdownItem[] = []; 
	public showList = false;
	public isSelected = false;

	ngOnInit() {
		this.filteredList = this.items.map(x => Object.assign({}, x)); 

		if (this.model.text) {
			this.isSelected = true;
		}
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes["items"]) {
			this.filteredList = this.items.map(x => Object.assign({}, x));
		}
	}

	setShowList(value: boolean) {
		this.showList = value;
	}

	selectItem(item: any) {
		this.model = Object.assign({}, item);
		this.showList = false;
		this.isSelected = true;

		let items = this.items.filter(i => this.model.value === i.value);
		this.autocompleteChanged.emit(items && items.length > 0 ? items[0] : undefined);
	}

	filterItems() {
		if (this.isSelected) {
			this.model = { text: "" };
		}
		this.filteredList = this.items.filter(x => (x.text || "")
			.toLowerCase()
			.trim()
			.indexOf((this.model.text || "")
				.toLowerCase()
				.trim()) > -1);
		this.autocompleteChanged.emit(undefined);
		this.isSelected = false;
	}
}
